export default __webpack_public_path__ + "static/media/moego-mac.badf44dd.png";